<template>
	<div class="app-list px-5">
		<app-table
			compact
			class="app-list-table mt-5 is-not-selectable"
			name="apps"
			:columns="columns"
			:column-widths="{ 1: '24%', 2: '18%', 3: '27%', 4: '11%', 5: '9%', 6: '11%' }"
			:current-page="currentPage"
			:rows="rows"
			:last-page="lastPage"
			@on-search-event="onSearch"
			@on-page="changePage"
		>
			<template slot="rows" slot-scope="props">
				<td class="app-main-cell is-not-selectable" v-show="showRow(columns, 1)">
					<div class="app-identity">
						<span class="app-avatar">{{ initials(props.row.name) }}</span>
						<div><strong :title="props.row.name">{{ props.row.name }}</strong><small>ID {{ props.row.id }}</small></div>
					</div>
				</td>
				<td class="app-code-cell" v-show="showRow(columns, 2)">
					<strong :title="props.row.codeApp">{{ props.row.codeApp || '—' }}</strong>
					<small>Código interno</small>
				</td>
				<td class="app-repository-cell" v-show="showRow(columns, 3)">
					<strong :title="props.row.repo">{{ props.row.repo || 'Sin repositorio' }}</strong>
					<small>Repositorio asociado</small>
				</td>
				<td class="app-modules-cell" v-show="showRow(columns, 4)">
					<strong>{{ modulesCount(props.row) }}</strong>
					<small>{{ modulesCount(props.row) === 1 ? 'módulo' : 'módulos' }}</small>
				</td>
				<td class="app-status-cell" v-show="showRow(columns, 5)">
					<span :class="{ maintenance: isInMaintenance(props.row) }">{{ isInMaintenance(props.row) ? 'Mantenimiento' : 'Activa' }}</span>
				</td>
				<td class="app-actions-cell">
					<app-tooltip-button
						color="green"
						icon="edit"
						text="Editar App"
						@click-icon="edit(props.row)"
					/>
					<app-tooltip-button
						color="primary"
						icon="link"
						text="Módulos"
						@click-icon="openModules(props.row)"
					/>
					<app-tooltip-button
						color="red"
						icon="delete"
						text="Eliminar App"
						@click-icon="openModalConfirmation(props.row)"
					/>
					<app-tooltip-button
						color="purple"
						icon="menu"
						text="Ver sidebar"
						@click-icon="goToSidebar(props.row)"
					/>
				</td>
			</template>
		</app-table>
		<app-confirmation-modal
			:loading="loading"
			:show-modal="modalConfirmation.value"
			@cancel="cancelModalConfirmation"
			@confirm="confirm()"
		/>
	</div>
</template>

<script>
import appTooltipButton from '@/components/shared/app-tooltip-button';
import appConfirmationModal from '@/components/shared/app-confirmation-modal';

function changePage(page) {
	this.$emit('change-page', page);
}

function confirm() {
	this.loading = true;
	this.$http
		.delete(`app/${this.modalConfirmation.selectedRow.id}`)
		.then(() => {
			this.showNotification('Registro eliminado correctamente');
			this.modalConfirmation.value = false;
			this.$emit('on-delete');
		})
		.finally(() => {
			this.loading = false;
		});
}

function edit({ id }) {
	this.goTo('page-app-edit', { params: { id } });
}

function initials(name = '') {
	return name.split(/\s+/)
		.filter(Boolean)
		.slice(0, 2)
		.map(word => word[0])
		.join('')
		.toUpperCase() || 'AP';
}

function isInMaintenance(row) {
	return Number(row.flagMaintenance) === 1;
}

function modulesCount(row) {
	const modules = row.module && row.module.data;
	return Array.isArray(modules) ? modules.length : 0;
}

function goToSidebar({ codeApp }) {
	this.goTo('page-sidebar', { params: { codeApp } });
}

function openModules({ codeApp }) {
	this.goTo('page-module', { params: { codeApp } });
}

function onSearch(value) {
	this.$emit('on-search', value);
}

function data() {
	return {
		loading: false,
	};
}

export default {
	name: 'apps-list',
	components: {
		appConfirmationModal,
		appTooltipButton,
	},
	data,
	methods: {
		changePage,
		confirm,
		edit,
		goToSidebar,
		initials,
		isInMaintenance,
		modulesCount,
		onSearch,
		openModules,
	},
	props: {
		columns: {
			type: Array,
			required: true,
		},
		currentPage: {
			type: Number,
			default: 0,
		},
		lastPage: {
			type: Number,
			default: 0,
		},
		rows: {
			type: Array,
			required: true,
		},
	},
};
</script>

<style lang="scss">
.app-list-table .table-list {
	table-layout: fixed;
	> tbody > tr,
	> tbody > tr > td { height: 46px !important; min-height: 46px !important; }
	> tbody > tr > td { padding-bottom: 3px !important; padding-top: 3px !important; }
}

.app-main-cell,
.app-code-cell,
.app-repository-cell,
.app-modules-cell { text-align: left !important; }
.app-identity { align-items: center; display: flex; gap: 8px; min-width: 0; }
.app-identity > div { display: flex; flex-direction: column; min-width: 0; }
.app-avatar { align-items: center; background: #e6f2fc; border-radius: 8px; color: #1A4338; display: flex; flex: 0 0 30px; font-size: 9px; font-weight: 700; height: 30px; justify-content: center; }
.app-main-cell strong,
.app-code-cell strong,
.app-repository-cell strong { color: #304a61; display: block; font-size: 11px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.app-main-cell small,
.app-code-cell small,
.app-repository-cell small,
.app-modules-cell small { color: #8496a6; display: block; font-size: 8px; margin-top: 2px; }
.app-modules-cell strong { color: #1A4338; display: block; font-size: 12px; }
.app-status-cell span { background: #e7f5ed; border-radius: 999px; color: #258457; display: inline-block; font-size: 9px; font-weight: 600; padding: 4px 8px; }
.app-status-cell span.maintenance { background: #fff2df; color: #c67918; }
.app-actions-cell { padding-left: 4px !important; padding-right: 4px !important; }
</style>



// WEBPACK FOOTER //
// src/components/apps/app-list.vue